export var IdSocialMedia;
(function (IdSocialMedia) {
    IdSocialMedia["FacebookAppId"] = "1753856974876029";
})(IdSocialMedia || (IdSocialMedia = {}));



//////////////////
// WEBPACK FOOTER
// ./src/constants/IdSocialMedia.ts
// module id = 2750
// module chunks = 3